import { render, staticRenderFns } from "./AreaTable.vue?vue&type=template&id=7124a4ac&scoped=true"
import script from "./AreaTable.vue?vue&type=script&lang=ts"
export * from "./AreaTable.vue?vue&type=script&lang=ts"
import style0 from "./AreaTable.vue?vue&type=style&index=0&id=7124a4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7124a4ac",
  null
  
)

export default component.exports